import { useContext, useEffect, useState } from 'react'
import UserContext from 'shared/components/context/user'
import CreationToolUserRestriction from '../types/user-restriction'

/**
 * Returns an array of creation restrictions the logged in user is able to see.
 */
export function useCreationAccess(): CreationToolUserRestriction[] {
    const [userAccess, setUserAccess] = useState<CreationToolUserRestriction[]>([])
    const { user } = useContext(UserContext)

    useEffect(() => {
        if (user.isStaff) {
            // allow staff members to access everything
            setUserAccess(CreationToolUserRestriction.all())
        } else {
            const access: CreationToolUserRestriction[] = [CreationToolUserRestriction.Everyone]

            // check user permissions
            if (user.permissions) {
                CreationToolUserRestriction.all().forEach(restriction => {
                    const permissionKeys = CreationToolUserRestriction.permissionKeys(restriction)
                    permissionKeys.forEach(permissionKey => {
                        if (access.indexOf(restriction) < 0 && user.permissions[permissionKey]) {
                            access.push(restriction)
                        }
                    })
                })
            }

            // user is logged in
            if (user.loggedIn) {
                access.push(CreationToolUserRestriction.LoggedInOnly)
            }

            // user has a verified account
            if (user.is_verified) {
                access.push(CreationToolUserRestriction.VerifiedOnly)
            }

            setUserAccess(access)
        }
    }, [user])

    return userAccess
}
